module.exports = __webpack_public_path__ + "static/media/cartao-exemplo.35ae29a6.png";